var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 2.75346C9.65675 2.75346 10.9999 4.09662 10.9999 5.75345C10.9999 7.41035 9.65675 8.75345 7.99992 8.75345C6.34304 8.75345 4.9999 7.41035 4.9999 5.75345C4.9999 4.09662 6.34304 2.75346 7.99992 2.75346ZM7.99992 3.87845C6.9644 3.87845 6.1249 4.71792 6.1249 5.75345C6.1249 6.78897 6.9644 7.62845 7.99992 7.62845C9.03545 7.62845 9.87492 6.78897 9.87492 5.75345C9.87492 4.71792 9.03545 3.87845 7.99992 3.87845ZM7.99992 0.125C11.46 0.125 14.447 2.48751 15.2757 5.7983C15.3512 6.09965 15.168 6.40512 14.8667 6.48057C14.5653 6.55595 14.2599 6.37287 14.1844 6.07145C13.4802 3.25847 10.9409 1.25 7.99992 1.25C5.0576 1.25 2.51748 3.26019 1.81455 6.0749C1.73928 6.37625 1.43392 6.55955 1.13252 6.48432C0.831115 6.40902 0.6478 6.1037 0.72307 5.80227C1.55039 2.48954 4.53827 0.125 7.99992 0.125Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.aacc459bdcfc2e19dd462d82bce22868.svg";
export { ForwardRef as ReactComponent };